<template>
  <section
    class="md:mt-8 m-auto bg-black pt-6 px-2 md:px-10 pb-5 shadow-black shadow-xl max-w-[1400px]"
  >
    <div
      id="message"
      class="h-[60vh] w-full text-white font-electro text-[24px] flex flex-col text-center pt-16 md:pt-4"
    >
      <div class="flex flex-col gap-4">
        <p class="uppercase text-[18px] py-4">Reset Password</p>
        <input type="email" id="userEmail" placeholder="Enter Email" name="emaila" required
          class="max-w-[300px] m-auto placeholder:text-[16px] text[16] text-black pl-2 placeholder:pl-2 rn-br" v-model="email" />
        <div class="flex flex-col gap-2">
          <p class="text-[14px]">Please enter your email address. We will send you a link to reset your password.</p>
        </div>
        <button v-if="emailIsValid" @click="resetPassword()"
          class="bg-[#ff0000] max-w-[200px] mt-4 m-auto text-[18px] px-8 py-2 rn-br">
          Reset Password
        </button>
        <p class="mt-4 m-auto text-[16px] rn-positive rn-br" v-if="result == 0">Your password was successfully reset.
          Please check your email.</p>
        <p class="mt-4 m-auto text-[16px] rn-negative rn-br" v-if="result == 1">Something bad happened. Please try again
        </p>
      </div>
    </div>
  </section>
  <section class="mt-8">
    <PartnersSmall partners-title="true" />
    <RallyLogoDownload link-text="Download Rally Navigator" />
  </section>
  <LoadingBar v-if="loading == true" message="Sending email..." />
</template>

<script>
import PartnersSmall from './PartnersSmall.vue';
import RallyLogoDownload from './RallyLogoDownload.vue';
import LoadingBar from './LoadingBar.vue';

export default {
  name: 'ResetPassword',
  components: {
    PartnersSmall,
    RallyLogoDownload,
    LoadingBar,
  },
  data() {
    return {
      result: -1,
      email: '',
      loading: false
    };
  },
  computed: {
    emailIsValid() {
      return this.email.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    },
  },
  methods: {
    async resetPassword() {
      this.loading = true;
      const response = await fetch(
        "https://api.rallynavigator.com/api/v2/auth/reset_password",
        {
          method: "POST",
          body: JSON.stringify({
            user: { email: this.email.toLowerCase() },
          }),
          headers: {
            "Content-Type": "application/json",
            "x-api-key": "Rw987ENLxJZyzB17Y3IH2Teu94IDLXl5AfWRsU50",
          },
        }
      );
      this.loading = false;
      //console.log(response)
      if (!response.ok) {
        //unvalid or expired token
        this.result = 1;
        return
      }
      const result = await response.json();
      if (result.success === true) {
        this.result = 0;
      } else {
        this.result = 1;
      }
    },

  },

};
</script>

<style scoped>
.rn-positive {
  background-color: green;
  border: 3px solid lightgreen;
  padding: 10px;
  min-width: 300px;
}

.rn-negative {
  background-color: darkred;
  border: 3px solid red;
  padding: 10px;
  min-width: 300px;
}

.rn-br {
  border-radius: 4px;
}

</style>
